var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Binary } from '../Binary';
import { EventEmitter } from './EventEmitter';
var Storage = /** @class */ (function () {
    function Storage(storageName, initialState) {
        this.storageName = storageName;
        this.initialState = initialState;
        this.emitter = new EventEmitter();
    }
    Storage.prototype.get = function () {
        if (!this.cache) {
            this.cache = __assign(__assign({}, this.initialState), this.read());
        }
        return this.cache;
    };
    Storage.prototype.upd = function (state) {
        this.cache = undefined;
        state = __assign(__assign({}, this.get()), state);
        this.write(state);
    };
    Storage.prototype.inc = function (key, inc) {
        var _a;
        if (inc === void 0) { inc = 1; }
        var state = this.get();
        if (typeof state[key] === 'number') {
            var value = (state[key] || 0);
            value += inc;
            state = __assign(__assign({}, state), (_a = {}, _a[key] = value, _a));
            this.cache = undefined;
            this.write(state);
            return value;
        }
        console.warn("\u041D\u0435\u0442 \u043A\u043B\u044E\u0447\u0430 \"".concat(String(key), "\" \u0438\u043B\u0438 \u044D\u0442\u043E \u043D\u0435 \u0447\u0438\u0441\u043B\u043E."));
        return 0;
    };
    Storage.prototype.dec = function (key, dec) {
        if (dec === void 0) { dec = 1; }
        return this.inc(key, -dec);
    };
    Storage.prototype.clear = function () {
        localStorage.removeItem(this.storageName);
    };
    Storage.prototype.on = function (name, cb) {
        this.emitter.on(name, cb);
    };
    Storage.prototype.read = function () {
        try {
            var json = localStorage.getItem(this.storageName);
            return json ? this.decode(json) : {};
        }
        catch (e) {
            console.error(e);
            // localStorage.removeItem(this.storageName)
        }
        return {};
    };
    Storage.prototype.write = function (state) {
        try {
            localStorage.setItem(this.storageName, this.encode(state));
            this.emitter.emit('write', state);
        }
        catch (e) {
            console.error(e);
        }
        this.cache = undefined;
    };
    Storage.prototype.encode = function (state) {
        return JSON.stringify(state);
    };
    Storage.prototype.decode = function (data) {
        return JSON.parse(data);
    };
    return Storage;
}());
export { Storage };
var BinaryStorage = /** @class */ (function (_super) {
    __extends(BinaryStorage, _super);
    function BinaryStorage(storageName, initialState) {
        var _this = _super.call(this, storageName, initialState) || this;
        var schema = {};
        for (var key in initialState) {
            if (!initialState.hasOwnProperty(key))
                continue;
            var value = initialState[key];
            if (typeof value === 'number') {
                schema[key] = new Binary.Int();
            }
            else if (typeof value === 'string') {
                schema[key] = new Binary.BinaryString();
            }
            else if (typeof value === 'boolean') {
                schema[key] = new Binary.Enum([false, true]);
            }
            else if (Array.isArray(value)) {
                schema[key] = new Binary.ArrayOf(new Binary.Int(0));
            }
            else {
                console.warn("not supported data type \"".concat(typeof value, "\" for key \"").concat(key, "\""));
            }
        }
        _this.packet = new Binary.Packet(schema);
        return _this;
    }
    BinaryStorage.prototype.encode = function (state) {
        return this.packet.encode(state);
    };
    BinaryStorage.prototype.decode = function (data) {
        // JSON
        if (data.substr(0, 2) === '{"') {
            return _super.prototype.decode.call(this, data);
        }
        return this.packet.decode(data);
    };
    return BinaryStorage;
}(Storage));
export { BinaryStorage };
